type BookmarkedJobResponse = {
  id: string;
  title: string;
  location?: string;
  source?: string; // Assuming 'source' can be a string like "company"
  isAccessible?: boolean;
  isBookmarked?: boolean;
  isDeactivated?: boolean;
  company?: string;
  salary?: string; // Contains a range, so kept as a string
  isPromoted?: boolean;
  isFeatured?: boolean;
  maxSalary?: number;
  releasedSinceDays: number;
};

export const formatBookmarkedJobs = ({
  id,
  title,
  location,
  source,
  isAccessible,
  isBookmarked,
  isDeactivated,
  company,
  salary,
  isPromoted,
  isFeatured,
  releasedSinceDays,
}: BookmarkedJobResponse) => ({
  id,
  title,
  company,
  salary,
  location,
  releasedSince: releasedSinceDays,
  isBookmarked,
  source,
  isAccessible,
  isDeactivated,
  isPromoted,
  isFeatured,
});

export default (item) => ({
  id: item[13],
  title: item[5].replace(/<.+?>/g, ''),
  company: item[6].replace(/<.+?>/g, ''),
  salary: item[7].replace(/<.+?>/g, ''),
  location: item[8].replace(/<.+?>/g, ''),
  releasedSince: item[12],
  isBookmarked: item[16],
  source: item[15],
  isAccessible: item[14],
  isFeatured: item.isFeatured,
  isPromoted: item.isPromoted,
  isDeactivated: item.isDeactivated,
  freeJobs: item.freeJobs,
});
